import {
  JSXElementConstructor,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import {useDispatch} from 'react-redux';
import NoticePopup from './NoticePopup';
import {Page} from '../../../common/constant/page';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {actions as commonSubActions} from '../../../commonSub/state/action';
import EventPopup from '../component/EventPopup';
import {actions} from '../state/action';
import {HomeTabPage, IMessageProps} from '../type';

export default function Messages() {
  const dispatch = useDispatch();
  const [curMessageType, setCurMessageType] = useState<IMessageType>('none');
  const [currentPage, currentTabPage] = useTypedSelector(state => [
    state.common.layoutProps.page,
    state.home.tabPage,
  ]);

  const onFinish = useCallback(() => {
    switch (curMessageType) {
      case 'notice':
        window.requestIdleCallback(() => setCurMessageType('event'));
        break;
      case 'event':
      default:
        setCurMessageType('none');
    }
  }, [curMessageType]);

  const targetRef = useRef<HTMLDivElement>(null);
  const isHiddenMessage =
    currentPage !== Page.Home ||
    currentTabPage !== HomeTabPage.Main ||
    curMessageType === 'none';

  const [isFetchUserFinished, user] = useTypedSelector(state => [
    state.auth.isFetchUserFinished,
    state.auth.user,
  ]);
  useEffect(() => {
    isFetchUserFinished && dispatch(actions.fetchMessages());
    // 로그인 이후 페이지 갱신 없는 경우 새로 받아오기 위해 user를 추가
  }, [dispatch, isFetchUserFinished, user]);

  useEffect(() => {
    setCurMessageType('notice');
  }, []);

  const showHomePopup = curMessageType !== 'none';
  useEffect(() => {
    dispatch(commonSubActions.setValue('showHomePopup', showHomePopup));
  }, [dispatch, showHomePopup]);

  if (isHiddenMessage) {
    return null;
  }

  const Message = MESSAGE_COMPONENT_MAP[curMessageType];
  return (
    <div
      ref={targetRef}
      className={cn('absolute inset-0 pointer-events-none z-message')}
    >
      <Message onFinish={onFinish} />
    </div>
  );
}

type IMessageType = 'none' | 'notice' | 'event';

const MESSAGE_COMPONENT_MAP: {
  [type in IMessageType]: JSXElementConstructor<IMessageProps>;
} = {
  none: () => null,
  notice: NoticePopup,
  event: EventPopup,
};
